module.exports = __webpack_public_path__ + "static/media/logo_SERDIPN.9576f9da.png";